import {environment} from "../environments/environment";

export class AppConstant {
  public static get frappeUrl(): string {
    return environment.FRAPPE_API_URL;
  }

  public static get adminUserId(): string {
    return "Administrator";
  }

  public static get vendorRole(): string {
    return "Vendor";
  }
}
